/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions
} from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { environment } from '@env/environment';
import { SignalRConfiguration, SignalRModule } from '@henkkelder/ng2-signalr';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
  GenericDialogComponent,
  GenericDialogModule
} from '@nibras/common-components/generic-dialog';
import { NibrasLoaderModule } from '@nibras/common-components/nibras-loader';
import { NibrasToastComponent, NibrasToastModule } from '@nibras/common-components/nibras-toast';
import { ViewFileModule } from '@nibras/common-components/view-file';
import {
  AuthGuard,
  AuthService,
  CoreModule,
  DIALOG_SERVICE,
  LocaleService,
  SNACKBAR_SERVICE,
  TOAST_SERVICE
} from '@nibras/core';
import { APP_CONFIG, APP_DI_CONFIG } from '@nibras/core/common';
import {
  DIALOG_COMPONENT_TYPE,
  DialogService,
  SnackbarService,
  ToastService
} from '@nibras/shared/services';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';

// AoT requires an exported function for factories
export function createConfig(): SignalRConfiguration {
  const config = new SignalRConfiguration();
  config.hubName = 'ServerPushBroadCastHub';
  config.qs = { user: 'MU57247' };
  config.url = environment.apiBaseUrl;
  config.logging = false;
  //config.transport = [ConnectionTransports.webSockets, ConnectionTransports.longPolling];
  return config;
}

export function localeIdFactory(localeService: LocaleService) {
  return localeService.getLocale();
}

export function localeInitializer(localeId: string) {
  return (): Promise<void> =>
    new Promise((resolve, reject) => {
      import(`/node_modules/@angular/common/locales/${localeId}.mjs`).then((module: any) => {
        registerLocaleData(module.default);
        resolve();
      }, reject);
    });
}

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  floatLabel: 'always',
  subscriptSizing: 'dynamic'
};

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(environment),
    EffectsModule.forRoot([]),
    HttpClientModule,
    GenericDialogModule,
    NibrasLoaderModule,
    NibrasToastModule,
    MatDialogModule,
    MatSnackBarModule,
    SignalRModule.forRoot(createConfig),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production // Restrict extension to log-only mode
    }),
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          // ANGULAR 13 UPGRADE
          // TODO this.store.dispatch(new SetSignalRConnectionAction(connection)); - stores mutable object to the state
          strictStateImmutability: false,
          strictActionImmutability: false
        }
      }
    ),
    ToastrModule.forRoot({ toastComponent: NibrasToastComponent }),
    ViewFileModule
  ],
  declarations: [AppComponent],
  exports: [HttpClientModule],
  providers: [
    AuthService,
    AuthGuard,
    {
      provide: APP_CONFIG,
      useValue: APP_DI_CONFIG
    },
    LocaleService,
    { provide: LOCALE_ID, useFactory: localeIdFactory, deps: [LocaleService] },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: localeInitializer,
      deps: [LOCALE_ID]
    },
    { provide: DIALOG_COMPONENT_TYPE, useValue: GenericDialogComponent },
    { provide: DIALOG_SERVICE, useClass: DialogService },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: SNACKBAR_SERVICE, useClass: SnackbarService },
    { provide: TOAST_SERVICE, useClass: ToastService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  // TODO: Diagnostic only: inspect router configuration
  constructor(router: Router) {
    //console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}
